<template>
    <button
        class="close-button c-hover n-pointer"
        @click="handleClick">
        <nicon
            icon="close"
            size="13" />
    </button>
</template>

<script setup lang="ts">
import { defineEmits } from 'vue';

interface Props {
    disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    disabled: false
});

const emit = defineEmits<{
    click: [event: MouseEvent];
}>();

const handleClick = (event: MouseEvent) => {
    if (!props.disabled) {
        emit('click', event);
    }
};
</script>

<style scoped lang="scss">
.close-button {
    color: var(--close-button-color);
    background: var(--close-button-bg);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    transition: all 0.2s ease;
    outline: none;
    user-select: none;
    white-space: nowrap;
    line-height: 1;
    border-radius: 50%;
    width: var(--close-button-height);
    height: var(--close-button-height);
    padding: 0;

    &:focus {
        outline: none;
    }
}
</style>
